import React from 'react';
import {
  ColumnDef,
  SortingState,
  PaginationState,
} from '@tanstack/react-table';

// Legacy column definition for backward compatibility
export interface DSOTableColumn {
  key: string;
  label: string;
  width?: number;
  render?: (value: any, row: any) => React.ReactNode;
  enableSorting?: boolean;
  sortDescFirst?: boolean;
}

export type TableRow = Record<string, any>;

export interface TableConfig {
  enableSorting?: boolean;
  enablePagination?: boolean;
  enableRowSelection?: boolean;
  enableColumnVisibility?: boolean;
  manualSorting?: boolean;
  manualPagination?: boolean;
  pageSize?: number;
  pageSizeOptions?: number[];
}

export interface DSOTableProps {
  columns: DSOTableColumn[];
  data: TableRow[];
  onRowClick?: (row: TableRow) => void;
  noDataMessage?: string;
  config?: TableConfig;
  onPaginationChange?: (pagination: PaginationState) => void;
  pageCount?: number;
  onSortingChange?: (sorting: SortingState) => void;
  initialSorting?: SortingState;
  onRowSelectionChange?: (selectedRows: TableRow[]) => void;
  // isLoading: true during the initial fetch (no rows yet) — shows a full-table spinner.
  // isFetchingMore: true when fetching subsequent pages — keeps existing rows and appends a spinner below them.
  isLoading?: boolean;
  isFetchingMore?: boolean;
  infiniteScrollRef?: React.RefCallback<HTMLElement>;
}

export interface TableHeaderProps {
  title?: string;
  onSearch?: (searchTerm: string) => void;
  searchPlaceholder?: string;
}
